import { render } from "./inputNumber.vue?vue&type=template&id=0bddacba&ts=true"
import script from "./inputNumber.vue?vue&type=script&lang=ts"
export * from "./inputNumber.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__